document.addEventListener('DOMContentLoaded', function() {    
  $('.activation_toggle').change(function() {
      const url = $(this).data("url");
      setTimeout(function() {
                    window.location.replace(url);
                }, 500);
  })
});